<template>
  <v-card width="94%" height="96%" class="grey lighten-3" style="position: absolute">
    <v-row
      class="d-flex justify-space-between mx-10"
      v-for="(item, index) in anamRoute"
      :key="index"
    >
      <v-col cols="1">
        <v-btn
          icon
          small
          class="primary mt-1"
          @click="insertRoute(item.pre)"
          v-if="item.pre != null"
        >
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
        <v-icon class="mx-4" v-else></v-icon>
      </v-col>
      <v-col cols="10">
        <div class="d-flex mt-2 justify-center text-subtitle-2 font-weight-medium">
          {{ item.title }}
        </div>
        <span class="d-flex justify-center text-caption mt-1" v-if="observerHCP === true">[ modo observador ]</span>
      </v-col>
      <v-col cols="1" class="d-flex justify-end">
        <v-btn
          icon
          small
          class="primary mt-1"
          @click="insertRoute(item.next)"
          v-if="item.next != null"
        >
          <v-icon>mdi-arrow-right</v-icon>
        </v-btn>
        <v-icon class="mx-4" v-else></v-icon>
      </v-col>
    </v-row>
    <v-divider class="pb-0 mb-0 mt-2"></v-divider>
  </v-card>
</template>

<script>
export default {
  name: 'VCardFormAnam',
  props: ['anamRoute', 'observerHCP'],
  data() {
    return {
      campos: [
        {
          etiqueta: 'v-text-field',
          label: 'esto es una caja de texto',
          valor: 'Vuejs',
          type: 'text',
        },
      ],
    };
  },
  methods: {
    insertRoute(ruta) {
      this.$router.push(ruta);
      this.$route.query;
    },
  },
  computed: {
    isRoute() {
      return this.$route.name === 'index';
    },
  },
};
</script>
